import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Plus, Minus, ShoppingBag, ArrowRight, ArrowLeft } from 'lucide-react';
import Header from './components/Header22';
import Footer from './components/Footer22';

const Cart22 = () => {
    const navigate = useNavigate();
    const [showEmpty, setShowEmpty] = useState(false);

    const [cartItems, setCartItems] = useState([
        {
            id: 1,
            name: 'Chanderi Silk Saree',
            price: 8999,
            quantity: 1,
            size: 'Free Size',
            craft: 'Handwoven, Chanderi',
            image: 'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 2,
            name: 'Banarasi Zari Lehenga',
            price: 15999,
            quantity: 1,
            size: 'M',
            craft: 'Zari Weave, Varanasi',
            image: 'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 3,
            name: 'Block Print Kurta Set',
            price: 4500,
            quantity: 2,
            size: 'S',
            craft: 'Block Print, Jaipur',
            image: 'https://images.pexels.com/photos/8838890/pexels-photo-8838890.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
    ]);

    const updateQuantity = (id, delta) => {
        setCartItems(items =>
            items.map(item =>
                item.id === id
                    ? { ...item, quantity: Math.max(1, item.quantity + delta) }
                    : item
            )
        );
    };

    const removeItem = (id) => {
        setCartItems(items => items.filter(item => item.id !== id));
    };

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const shipping = subtotal > 2999 ? 0 : 149;
    const total = subtotal + shipping;

    if (showEmpty || cartItems.length === 0) {
        return (
            <>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Infant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');
                `}</style>
                <div style={{ minHeight: '100vh', backgroundColor: '#FAF6F1', fontFamily: "'Source Sans 3', -apple-system, sans-serif" }}>
                    <Header />
                    <div style={{
                        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                        minHeight: '60vh', padding: '120px 24px 80px', textAlign: 'center',
                    }}>
                        <div style={{
                            width: '80px', height: '80px', borderRadius: '50%',
                            backgroundColor: '#F3ECE4', display: 'flex',
                            alignItems: 'center', justifyContent: 'center', marginBottom: '24px',
                        }}>
                            <ShoppingBag size={32} color="#C4572A" />
                        </div>
                        <h2 style={{
                            fontFamily: "'Cormorant Infant', Georgia, serif",
                            fontSize: '32px', fontWeight: 500, color: '#5C3D2E', marginBottom: '12px',
                        }}>
                            Your Cart is Empty
                        </h2>
                        <p style={{ fontSize: '16px', color: '#8B7355', marginBottom: '32px', maxWidth: '400px' }}>
                            Explore our handcrafted collection and find something that speaks to your soul.
                        </p>
                        <button
                            onClick={() => navigate('/template22/shop')}
                            style={{
                                padding: '14px 36px', backgroundColor: '#C4572A', color: '#FFFFFF',
                                border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: 600,
                                letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer',
                                fontFamily: "'Source Sans 3', sans-serif", transition: 'all 0.3s ease',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#D4683B'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C4572A'; }}
                        >
                            Explore Collection
                        </button>
                    </div>
                    <Footer />
                </div>
            </>
        );
    }

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Infant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');

                .maati-cart-layout {
                    display: flex;
                    flex-direction: column;
                    gap: 32px;
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 120px 24px 80px;
                }
                @media (min-width: 1024px) {
                    .maati-cart-layout {
                        flex-direction: row;
                        gap: 48px;
                    }
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FAF6F1', fontFamily: "'Source Sans 3', -apple-system, sans-serif" }}>
                <Header cartCount={cartItems.length} />

                <div className="maati-cart-layout">
                    {/* Cart Items */}
                    <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '32px' }}>
                            <h1 style={{
                                fontFamily: "'Cormorant Infant', Georgia, serif",
                                fontSize: '36px', fontWeight: 500, color: '#5C3D2E', margin: 0,
                            }}>
                                Shopping Cart
                            </h1>
                            <p style={{ fontSize: '14px', color: '#8B7355' }}>
                                {cartItems.length} {cartItems.length === 1 ? 'item' : 'items'}
                            </p>
                        </div>

                        {/* Handcrafted Message */}
                        <div style={{
                            backgroundColor: '#F3ECE4', borderRadius: '8px', padding: '14px 20px',
                            marginBottom: '24px', borderLeft: '3px solid #C4572A',
                            display: 'flex', alignItems: 'center', gap: '10px',
                        }}>
                            <span style={{ fontSize: '14px', color: '#5C3D2E' }}>
                                Each piece is <strong>handcrafted with love</strong> by Indian artisans. Thank you for supporting traditional craft.
                            </span>
                        </div>

                        {cartItems.map((item, index) => (
                            <div
                                key={item.id}
                                style={{
                                    display: 'flex',
                                    gap: '20px',
                                    padding: '24px',
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '10px',
                                    border: '1px solid #E8DDD0',
                                    marginBottom: index < cartItems.length - 1 ? '16px' : '0',
                                }}
                            >
                                {/* Image */}
                                <div
                                    onClick={() => navigate(`/template22/product/${item.id}`)}
                                    style={{
                                        width: '120px', height: '150px', borderRadius: '8px',
                                        overflow: 'hidden', flexShrink: 0, cursor: 'pointer',
                                    }}
                                >
                                    <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>

                                {/* Details */}
                                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            <div>
                                                <h3 style={{
                                                    fontFamily: "'Cormorant Infant', Georgia, serif",
                                                    fontSize: '20px', fontWeight: 600, color: '#5C3D2E',
                                                    margin: '0 0 4px 0',
                                                }}>
                                                    {item.name}
                                                </h3>
                                                <p style={{ fontSize: '13px', color: '#8B7355', margin: '0 0 2px 0', fontStyle: 'italic' }}>
                                                    {item.craft}
                                                </p>
                                                <p style={{ fontSize: '13px', color: '#8B7355', margin: 0 }}>
                                                    Size: {item.size}
                                                </p>
                                            </div>
                                            <button
                                                onClick={() => removeItem(item.id)}
                                                style={{
                                                    background: 'none', border: 'none', cursor: 'pointer',
                                                    padding: '4px', color: '#8B7355', transition: 'color 0.2s',
                                                }}
                                                onMouseEnter={(e) => { e.currentTarget.style.color = '#C4572A'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.color = '#8B7355'; }}
                                            >
                                                <X size={18} />
                                            </button>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
                                        {/* Quantity */}
                                        <div style={{
                                            display: 'flex', alignItems: 'center',
                                            border: '1px solid #E8DDD0', borderRadius: '6px', overflow: 'hidden',
                                        }}>
                                            <button
                                                onClick={() => updateQuantity(item.id, -1)}
                                                style={{
                                                    width: '36px', height: '36px', border: 'none',
                                                    backgroundColor: 'transparent', cursor: 'pointer',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    color: '#5C3D2E',
                                                }}
                                            >
                                                <Minus size={14} />
                                            </button>
                                            <span style={{
                                                width: '36px', textAlign: 'center', fontSize: '14px',
                                                fontWeight: 600, color: '#5C3D2E',
                                                borderLeft: '1px solid #E8DDD0', borderRight: '1px solid #E8DDD0',
                                                lineHeight: '36px',
                                            }}>
                                                {item.quantity}
                                            </span>
                                            <button
                                                onClick={() => updateQuantity(item.id, 1)}
                                                style={{
                                                    width: '36px', height: '36px', border: 'none',
                                                    backgroundColor: 'transparent', cursor: 'pointer',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    color: '#5C3D2E',
                                                }}
                                            >
                                                <Plus size={14} />
                                            </button>
                                        </div>

                                        <p style={{
                                            fontSize: '18px', fontWeight: 700, color: '#C4572A', margin: 0,
                                            fontFamily: "'Cormorant Infant', serif",
                                        }}>
                                            {'\u20B9'}{(item.price * item.quantity).toLocaleString('en-IN')}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* Continue Shopping */}
                        <button
                            onClick={() => navigate('/template22/shop')}
                            style={{
                                display: 'flex', alignItems: 'center', gap: '8px',
                                marginTop: '24px', background: 'none', border: 'none',
                                cursor: 'pointer', fontSize: '14px', color: '#C4572A',
                                fontFamily: "'Source Sans 3', sans-serif", fontWeight: 500,
                            }}
                        >
                            <ArrowLeft size={16} /> Continue Shopping
                        </button>
                    </div>

                    {/* Order Summary */}
                    <div style={{ width: '100%', maxWidth: '400px' }}>
                        <div style={{
                            backgroundColor: '#FFFFFF', borderRadius: '12px',
                            border: '1px solid #E8DDD0', padding: '32px',
                            position: 'sticky', top: '100px',
                        }}>
                            <h2 style={{
                                fontFamily: "'Cormorant Infant', Georgia, serif",
                                fontSize: '24px', fontWeight: 600, color: '#5C3D2E',
                                margin: '0 0 24px 0',
                            }}>
                                Order Summary
                            </h2>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '20px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                                    <span style={{ color: '#8B7355' }}>Subtotal</span>
                                    <span style={{ color: '#5C3D2E', fontWeight: 500 }}>{'\u20B9'}{subtotal.toLocaleString('en-IN')}</span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px' }}>
                                    <span style={{ color: '#8B7355' }}>Shipping</span>
                                    <span style={{ color: shipping === 0 ? '#2E7D32' : '#5C3D2E', fontWeight: 500 }}>
                                        {shipping === 0 ? 'Free' : `\u20B9${shipping}`}
                                    </span>
                                </div>
                                {shipping === 0 && (
                                    <p style={{ fontSize: '12px', color: '#2E7D32', margin: 0, fontStyle: 'italic' }}>
                                        Free shipping on orders above {'\u20B9'}2,999
                                    </p>
                                )}
                            </div>

                            <div style={{
                                borderTop: '1px solid #E8DDD0', paddingTop: '16px', marginBottom: '24px',
                                display: 'flex', justifyContent: 'space-between',
                            }}>
                                <span style={{ fontSize: '18px', fontWeight: 600, color: '#5C3D2E' }}>Total</span>
                                <span style={{
                                    fontSize: '24px', fontWeight: 700, color: '#C4572A',
                                    fontFamily: "'Cormorant Infant', serif",
                                }}>
                                    {'\u20B9'}{total.toLocaleString('en-IN')}
                                </span>
                            </div>

                            {/* Coupon */}
                            <div style={{
                                display: 'flex', gap: '8px', marginBottom: '24px',
                            }}>
                                <input
                                    type="text"
                                    placeholder="Coupon code"
                                    style={{
                                        flex: 1, padding: '12px 16px', border: '1px solid #E8DDD0',
                                        borderRadius: '6px', fontSize: '14px', color: '#5C3D2E',
                                        backgroundColor: '#FFFFFF', outline: 'none',
                                        fontFamily: "'Source Sans 3', sans-serif",
                                    }}
                                />
                                <button style={{
                                    padding: '12px 20px', backgroundColor: '#F3ECE4',
                                    border: '1px solid #E8DDD0', borderRadius: '6px',
                                    fontSize: '13px', fontWeight: 600, color: '#5C3D2E',
                                    cursor: 'pointer', fontFamily: "'Source Sans 3', sans-serif",
                                    transition: 'all 0.2s ease',
                                }}>
                                    Apply
                                </button>
                            </div>

                            <button
                                onClick={() => navigate('/template22/checkout')}
                                style={{
                                    width: '100%', padding: '16px', backgroundColor: '#C4572A',
                                    color: '#FFFFFF', border: 'none', borderRadius: '8px',
                                    fontSize: '15px', fontWeight: 600, letterSpacing: '1px',
                                    textTransform: 'uppercase', cursor: 'pointer',
                                    fontFamily: "'Source Sans 3', sans-serif",
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                                    transition: 'all 0.3s ease',
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#D4683B'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C4572A'; }}
                            >
                                Proceed to Checkout <ArrowRight size={18} />
                            </button>

                            <p style={{
                                fontSize: '12px', color: '#8B7355', textAlign: 'center',
                                marginTop: '16px', lineHeight: 1.5,
                            }}>
                                Secure checkout powered by Razorpay. Your handcrafted pieces will be carefully packaged.
                            </p>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Cart22;
